// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 批量更新用户权限组关联 为多个用户批量绑定或解绑权限组接口 POST /bossApi/conference/core/permission/v1/batchUpdateUserPermissionGroupRel */
export async function batchUpdateUserPermissionGroupRel(
  body: CoreAPI.BatchUpdateUserPermissionGroupRelHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseBatchUpdateResultVO>(
    '/bossApi/conference/core/permission/v1/batchUpdateUserPermissionGroupRel',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 删除权限组 删除权限组接口 POST /bossApi/conference/core/permission/v1/deletePermissionGroup */
export async function deletePermissionGroup(
  body: CoreAPI.DeletePermissionGroupHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.BaseResponse>(
    '/bossApi/conference/core/permission/v1/deletePermissionGroup',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 获取当前用户权限快照 获取当前登录用户的完整权限快照接口 POST /bossApi/conference/core/permission/v1/getCurrentUserPermissionSnapshot */
export async function getCurrentUserPermissionSnapshot(
  body: CoreAPI.GetCurrentUserPermissionSnapshotHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseCurrentUserPermissionSnapshotVO>(
    '/bossApi/conference/core/permission/v1/getCurrentUserPermissionSnapshot',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询权限组 根据ID查询权限组详情 POST /bossApi/conference/core/permission/v1/getPermissionGroup */
export async function getPermissionGroup(
  body: CoreAPI.GetPermissionGroupHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponsePermissionGroupVO>(
    '/bossApi/conference/core/permission/v1/getPermissionGroup',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 新增权限组 新增权限组接口，返回权限组ID POST /bossApi/conference/core/permission/v1/insertPermissionGroup */
export async function insertPermissionGroup(
  body: CoreAPI.InsertPermissionGroupHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseString>(
    '/bossApi/conference/core/permission/v1/insertPermissionGroup',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询权限组列表 查询权限组列表接口 POST /bossApi/conference/core/permission/v1/listPermissionGroup */
export async function listPermissionGroup(
  body: CoreAPI.ListPermissionGroupHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseListPermissionGroupVO>(
    '/bossApi/conference/core/permission/v1/listPermissionGroup',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询权限组权限列表 查询权限组权限点列表接口 POST /bossApi/conference/core/permission/v1/listPermissionGroupPermissions */
export async function listPermissionGroupPermissions(
  body: CoreAPI.GetPermissionGroupHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseListPermissionPointVO>(
    '/bossApi/conference/core/permission/v1/listPermissionGroupPermissions',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询权限组用户列表 查询指定权限组下的用户列表接口 POST /bossApi/conference/core/permission/v1/listPermissionGroupUsers */
export async function listPermissionGroupUsers(
  body: CoreAPI.ListPermissionGroupUsersHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseListPermissionGroupUserVO>(
    '/bossApi/conference/core/permission/v1/listPermissionGroupUsers',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询权限点列表 查询完整权限点列表接口，支持按类型和关键字搜索 POST /bossApi/conference/core/permission/v1/listPermissionPoint */
export async function listPermissionPoint(
  body: CoreAPI.ListPermissionPointHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseListPermissionPointVO>(
    '/bossApi/conference/core/permission/v1/listPermissionPoint',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询权限点树结构 查询完整权限点树结构接口，支持按类型和关键字搜索，返回树形嵌套结构 POST /bossApi/conference/core/permission/v1/listPermissionPointTree */
export async function listPermissionPointTree(
  body: CoreAPI.ListPermissionPointHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseListPermissionPointTreeVO>(
    '/bossApi/conference/core/permission/v1/listPermissionPointTree',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询用户权限编码列表 查询指定用户拥有的所有权限编码接口，支持通过用户ID或用户名查询 POST /bossApi/conference/core/permission/v1/listUserPermissionCodes */
export async function listUserPermissionCodes(
  body: CoreAPI.ListUserPermissionCodesHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseListUserPermissionCodeVO>(
    '/bossApi/conference/core/permission/v1/listUserPermissionCodes',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询用户权限组列表 查询指定用户已绑定的权限组列表接口 POST /bossApi/conference/core/permission/v1/listUserPermissionGroups */
export async function listUserPermissionGroups(
  body: CoreAPI.ListUserPermissionGroupsHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseListUserPermissionGroupVO>(
    '/bossApi/conference/core/permission/v1/listUserPermissionGroups',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询用户权限点树结构 查询指定用户拥有的所有权限点树结构接口，支持通过用户ID或用户名查询 POST /bossApi/conference/core/permission/v1/listUserPermissionPointsTree */
export async function listUserPermissionPointsTree(
  body: CoreAPI.ListUserPermissionPointsHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseListPermissionPointTreeVO>(
    '/bossApi/conference/core/permission/v1/listUserPermissionPointsTree',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 更新权限组 更新权限组接口 POST /bossApi/conference/core/permission/v1/updatePermissionGroup */
export async function updatePermissionGroup(
  body: CoreAPI.UpdatePermissionGroupHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.BaseResponse>(
    '/bossApi/conference/core/permission/v1/updatePermissionGroup',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 更新权限组权限关联 为权限组配置权限点接口 POST /bossApi/conference/core/permission/v1/updatePermissionGroupPermission */
export async function updatePermissionGroupPermission(
  body: CoreAPI.UpdatePermissionGroupPermissionHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.BaseResponse>(
    '/bossApi/conference/core/permission/v1/updatePermissionGroupPermission',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 更新用户权限组关联 为用户绑定或解绑权限组接口 POST /bossApi/conference/core/permission/v1/updateUserPermissionGroupRel */
export async function updateUserPermissionGroupRel(
  body: CoreAPI.UpdateUserPermissionGroupRelHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.BaseResponse>(
    '/bossApi/conference/core/permission/v1/updateUserPermissionGroupRel',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}
